import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'

export default function useSeo() {
  const globalStore = useGlobalStore()

  const title = `歷期雜誌｜hengstyle Life｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = globalStore.seoDescriptions.magazine
  const url = `${import.meta.env.VITE_DOMAIN}/hence/magazine`

  globalStore.setBreadcrumbs([
    { title: 'hengstyle Life', isActive: false, url: '/hence' },
    { title: '歷期雜誌', isActive: true, url: '/hence/magazine' }
  ])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description
    // ogImage: faq.value.seo?.og_image?.link,
    // keywords: faq.value.seo?.meta_keywords.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })
  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'hengstyle Life',
            item: `${import.meta.env.VITE_DOMAIN}/hence`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: '歷期雜誌',
            item: url
          }
        ]
      }
    ]
  })
}
